import { actions } from "@src/Actions/Reducers/GlobalModalsReducer"
import { usePortalSize } from "@src/Components/Common/usePortalSize"
import C from "@src/Controller"
import { useLocale } from "@src/Hooks/useLocale"
import { tState } from "@src/Model/Model"
import {
  ConfirmationModal,
  FaIcon,
  Section,
  Text,
} from "@zeguro/component-library"
import * as React from "react"
import { useDispatch, useSelector } from "react-redux"

const ChangeLanguageConfirmationModal = () => {
  const dispatch = useDispatch()
  const { redirectToLocale } = useLocale()
  const { isDesktop, onBoarding } = usePortalSize()
  const cognitoId = useSelector((state: tState) => state.portal.cognitoId)
  const isZeguroServiceSession = useSelector(
    (state: tState) => state.portal.isZeguroServiceSession,
  )
  const [isLoading, setIsLoading] = React.useState(false)

  const isOpen = useSelector(
    (state: tState) => state.globalModals.languageChangeModalState.isOpen,
  )
  const pendingLocale = useSelector(
    (state: tState) =>
      state.globalModals.languageChangeModalState.pendingLocale,
  )

  const handleClose = () => {
    dispatch(actions.closeLanguageModal())
  }

  const closeAndRedirect = () => {
    dispatch(actions.closeLanguageModal())
    redirectToLocale(pendingLocale)
  }

  const handleConfirm = () => {
    if (pendingLocale) {
      if (cognitoId && !isZeguroServiceSession && !onBoarding) {
        setIsLoading(true)
        C.Portal.editUser(
          cognitoId,
          {
            locale: pendingLocale,
          },
          (res: { success: boolean } | boolean) => {
            setIsLoading(false)
            if (typeof res === "object" && res.success) {
              closeAndRedirect()
            }
          },
          true,
        )
      } else {
        closeAndRedirect()
      }
    }
  }

  return (
    <ConfirmationModal
      type="warning"
      width={isDesktop ? "435px" : "375px"}
      isOpen={isOpen}
      actionText="Change Language"
      title="Change Language?"
      actionButtonVariant="secondary"
      handleClose={handleClose}
      handleAction={handleConfirm}
      isActionLoading={isLoading}
      body={
        <Section>
          <FaIcon iconType="far" iconName="exclamation-triangle" />{" "}
          <Text fontSize="16px">
            Are you sure you want to change your display language? This may also
            change your current page.
          </Text>
        </Section>
      }
    />
  )
}

export default ChangeLanguageConfirmationModal
